var buildType = 'PRODUCTION';
var appType = 'web';
var APIUrl = {
    UAT: 'http://localhost:6025/api/',
    BETA: '',
    PRODUCTION: 'https://cc.uoiquality.com/api/',
};
var UploaderAPIUrl = {
    UAT: 'http://localhost:6027/',
    BETA: '',
    PRODUCTION: 'https://cc.uoiquality.com/upload/',
};
var internalPortalUrl = {
    UAT: 'http://localhost:8080/',
    BETA: '',
    PRODUCTION: 'https://cc.uoiquality.com/',
};
export var getAppEnv = function () {
    return buildType;
};
export var getAppType = function () {
    return appType;
};
export var isDev = function () {
    return process.env.NODE_ENV !== 'production';
};
export var getBaseAPIUrl = function () {
    return APIUrl[buildType];
};
export var getUploaderAPIUrl = function () {
    return UploaderAPIUrl[buildType];
};
export var getInternalPortalUrl = function () {
    return internalPortalUrl[buildType];
};
export var initAppConfig = function (_appType, _buildType) {
    buildType = _buildType;
    appType = _appType;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwQ29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0NvbmZpZ3MvQXBwQ29uZmlnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUksU0FBUyxHQUFjLFlBQVksQ0FBQztBQUN4QyxJQUFJLE9BQU8sR0FBWSxLQUFLLENBQUM7QUFFN0IsSUFBTSxNQUFNLEdBQUc7SUFDYixHQUFHLEVBQUUsNEJBQTRCO0lBQ2pDLElBQUksRUFBRSxFQUFFO0lBQ1IsVUFBVSxFQUFFLGdDQUFnQztDQUM3QyxDQUFDO0FBRUYsSUFBTSxjQUFjLEdBQUc7SUFDckIsR0FBRyxFQUFFLHdCQUF3QjtJQUM3QixJQUFJLEVBQUUsRUFBRTtJQUNSLFVBQVUsRUFBRSxtQ0FBbUM7Q0FDaEQsQ0FBQztBQUVGLElBQU0saUJBQWlCLEdBQUc7SUFDeEIsR0FBRyxFQUFFLHdCQUF3QjtJQUM3QixJQUFJLEVBQUUsRUFBRTtJQUNSLFVBQVUsRUFBRSw0QkFBNEI7Q0FDekMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLFNBQVMsR0FBRztJQUN2QixPQUFPLFNBQVMsQ0FBQztBQUNuQixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxVQUFVLEdBQUc7SUFDeEIsT0FBTyxPQUFPLENBQUM7QUFDakIsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sS0FBSyxHQUFHO0lBQ25CLE9BQU8sT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssWUFBWSxDQUFDO0FBQy9DLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRztJQUMzQixPQUFPLE1BQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUMzQixDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBRztJQUMvQixPQUFPLGNBQWMsQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUNuQyxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FBRztJQUNsQyxPQUFPLGlCQUFpQixDQUFDLFNBQVMsQ0FBQyxDQUFDO0FBQ3RDLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxVQUFDLFFBQWlCLEVBQUUsVUFBcUI7SUFDcEUsU0FBUyxHQUFHLFVBQVUsQ0FBQztJQUN2QixPQUFPLEdBQUcsUUFBUSxDQUFDO0FBQ3JCLENBQUMsQ0FBQyJ9